import type { Entitlements, EntitlementType, UserEntitlement } from '@/api/types/entitlementsTypes';

export function parseEntitlements(data: any): Entitlements {
  const results = Array.isArray(data?.results) ? data.results.map(parseUserEntitlement) : [];

  return {
    results,
    parsedProps: {
      isSubscribed: isSubscribed(results),
      isFoxOneSubscriber: isSubscriberSku(results, 'us.foxone'),
      isFoxNationSubscriber: isSubscriberSku(results, 'us.foxnation'),
    },
  };
}

function parseUserEntitlement(item: any): UserEntitlement {
  return {
    contentSku: item?.contentSku || '',
    entitlementType: item?.entitlementType ?? [],
    proxiedEntitlement: Boolean(item?.proxiedEntitlement),
    startDate: item?.startDate || '',
  };
}

function isSubscriberSku(results: UserEntitlement[], sku: string, entitlementType?: EntitlementType): boolean {
  if (entitlementType) {
    return results.some((e) => e.contentSku === sku && e.entitlementType.includes(entitlementType));
  }

  return results.some(
    (e) => e.contentSku === sku && (e.entitlementType.includes('subs') || e.entitlementType.includes('mvpd')),
  );
}

// Checks for any user entitlements besides us.free
function isSubscribed(results: UserEntitlement[]): boolean {
  return results.some(
    (e) => e.contentSku !== 'us.free' && (e.entitlementType.includes('subs') || e.entitlementType.includes('mvpd')),
  );
}
